import axios from "axios";
import { redirectToLoginIfSessionExpired } from "./authExpired";

// Request interceptor: add Accept-Language from app locale so backend returns localized content
axios.interceptors.request.use((config) => {
  const lng = localStorage.getItem("lng") || localStorage.getItem("i18nextLng") || "en";
  const langCode = lng.split("-")[0].split("_")[0]; // "fr-FR" -> "fr", "fr_LU" -> "fr"
  const normalized =
    langCode === "gr" ? "de" : langCode === "sp" ? "es" : langCode;
  if (normalized && !config.headers["Accept-Language"]) {
    config.headers["Accept-Language"] = `${normalized}, en;q=0.9`;
  }
  return config;
});

// Response interceptor to handle token expiration globally
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && redirectToLoginIfSessionExpired(error.response.status, error.response.data)) {
      return Promise.reject(new Error("Token expired - redirected to login"));
    }
    return Promise.reject(error);
  }
);

// Export default axios (now with interceptor)
export default axios;
